import * as React from "react";
import { createStyles, Divider, Group } from "@mantine/core";
import {
	_defaultCopyright,
	_defaultImpressum,
	_defaultPrivacyPolicy,
} from "../constants";
import { Icon, ICONS } from "../icons/Icon";

const useStyles = createStyles((_theme, _params, _getRef) => ({
	footer: {
		width: "100%",
		paddingTop: 40,
		paddingBottom: 16,
		backgroundColor: "#f1f3f4",
	},
	container: {
		maxWidth: 970,
		width: "74%",
	},
	logoLine: {
		height: 40,
		width: "100%",
	},
	logo: {
		height: "2rem",
	},
	vsethText: {
		fontWeight: 800,
		color: "gray",
		height: 20,
	},
	divider: { marginTop: "1rem", marginBottom: "1rem" },
	disclaimer: { color: "gray" },
	icon: {
		backgroundColor: _theme.colors.vsethMain?.[7],
		borderRadius: 100,
		width: 35,
		height: 35,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginTop: 10,
	},
}));

const getIconString = (
	type: "twitter" | "facebook" | "instagram" | "email"
) => {
	switch (type) {
		case "twitter":
			return ICONS.TWITTER;
		case "facebook":
			return ICONS.FACEBOOK;
		case "instagram":
			return ICONS.INSTAGRAM;
		case "email":
			return ICONS.EMAIL;
	}
};

interface Props {
	disclaimer: string | undefined;
	privacyPolicy: string | undefined;
	impressum: string | undefined;
	socialMedia:
		| {
				type: "facebook" | "twitter" | "instagram" | "email";
				link: string;
		  }[]
		| undefined;
}

const _Footer: React.FC<Props> = ({
	disclaimer,
	privacyPolicy,
	impressum,
	socialMedia,
}) => {
	const { classes } = useStyles();

	return (
		<Group className={classes.footer} align="center" position="center">
			<div className={classes.container}>
				<Group className={classes.logoLine} align="center" position="apart">
					<a target="_blank" href="https://vseth.ethz.ch">
						<img
							src="https://fe.vseth.ethz.ch/assets/vseth-byline.svg"
							className={classes.logo}
						/>
					</a>
					<div className={classes.vsethText}>VSETH</div>
				</Group>
				<Group>
					{socialMedia?.map((item, i) => (
						<a
							key={i}
							target="_blank"
							href={item.link}
							className={classes.icon}
						>
							<Icon icon={getIconString(item.type)} size={15} color="white" />
						</a>
					))}
				</Group>
				<Divider size="xl" color="primaryColor" className={classes.divider} />
				<Group position="apart">
					<div className={classes.disclaimer}>
						{disclaimer ? disclaimer : _defaultCopyright}
					</div>
					<Group>
						<div className={""}>
							<a
								target="_blank"
								href={privacyPolicy ? privacyPolicy : _defaultPrivacyPolicy}
							>
								Privacy Policy
							</a>
						</div>{" "}
						<div className={""}>
							<a
								target="_blank"
								href={impressum ? impressum : _defaultImpressum}
							>
								Impressum
							</a>
						</div>
					</Group>
				</Group>
			</div>
		</Group>
	);
};

export default _Footer;
